import React from "react";

import { Card } from "@/components/ui/card";
import { cn, formatNumber } from "@/lib/utils";

interface ChartCardProps {
    children: React.ReactNode;
    title: string;
    subtitle?: string;
    value?: number;
    className?: string;
}

const ChartCard = ({ children, title, subtitle, value, className }: ChartCardProps) => {
    return (
        <Card className={cn(className, "py-3 pr-3")}>
            <div className="px-8 text-gray-700">
                <div className="flex items-center gap-3 ">
                    <h3 className="text-xl font-bold">{title}</h3>
                    {value && <h4 className="text-2xl font-bold">{formatNumber(value)}</h4>}
                </div>
                {subtitle ? <h4 className="text-sm text-gray-500">{subtitle}</h4> : <span className="block min-h-[22px]"></span>}
            </div>
            <div className="mt-3">{children}</div>
        </Card>
    );
};

export default ChartCard;
